export default "__VITE_ASSET__BPcmy4Gv__"